import { userInfoSync } from 'hub-http/userInfo';
import { useMemo } from 'react';
import { ABUSE_DESK_CHIRP_GATE } from '../constants/gates';
import { SINGLE_RPC_MAP } from '../api/rpcMethods';
export const useUserInfo = keyword => {
  const cachedUserInfo = useMemo(() => {
    try {
      const userInfo = userInfoSync();
      return userInfo;
    } catch (_unused) {
      return undefined;
    }
  }, []);
  const gates = cachedUserInfo === null || cachedUserInfo === void 0 ? void 0 : cachedUserInfo.gates;
  const hasRpcGate = useMemo(() => !!(gates && gates.includes(ABUSE_DESK_CHIRP_GATE) && keyword && SINGLE_RPC_MAP[keyword]), [gates, keyword]);
  return {
    gates: cachedUserInfo === null || cachedUserInfo === void 0 ? void 0 : cachedUserInfo.gates,
    hasRpcGate
  };
};